let timer: ReturnType<typeof setTimeout>;

export const debounce = (cb: () => void, clearInterval = true, time = 2000) => {
  if (clearInterval) clearTimeout(timer);
  timer = setTimeout(() => {
    cb();
  }, time);
};
